module.exports = __webpack_public_path__ + "img/edit.0c1b529a.svg";